module.exports = __webpack_public_path__ + "media/images/products/longlife/detail-img-1-4f4d21b03ad39ea1e19ffe769ba619ed.png";